// extracted by mini-css-extract-plugin
module.exports = {"Remote":"index-module--Remote--1s9Yf","commandRemote":"index-module--commandRemote--1lYjJ","remote":"index-module--remote--3EoNR"};